export default function getReducerHandler(state, action, handlers) {
  const type = action?.type ?? action?.actionType
  const handler = handlers[type]
  if (!handler) throw Error(`ERROR: Unhandled action type: ${type}`)
  return handler(state, action)
}
